import { render, staticRenderFns } from "./risposteQualita.vue?vue&type=template&id=554b933c&"
import script from "./risposteQualita.vue?vue&type=script&lang=ts&"
export * from "./risposteQualita.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports